module.exports = __webpack_public_path__ + "media/images/help-icon-23819e4b824617e32e2b180db84674f9.svg";